import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListItem from 'flarum/forum/dianLiang/DlDiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import extractText from 'flarum/common/utils/extractText';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import TagSelectionModal from 'flarum/tags/components/TagSelectionModal';
import tagIcon from 'flarum/tags/helpers/tagIcon';
import tagLabel from 'flarum/tags/helpers/tagLabel';
import highlight from 'flarum/common/helpers/highlight';
import PostControls from 'flarum/forum/utils/PostControls';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import CommentPost from 'flarum/forum/components/CommentPost';
import Dropdown from 'flarum/common/components/Dropdown';
import HomePage from './components/HomePage';
import IndexPage from 'flarum/forum/components/IndexPage';

export default function () {

  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (this.params.sort === 'essence') {
      if (params.filter.q) {
        params.filter.q = (params.filter.q || '') + 'is:essence';
      } else {
        params.filter.essence = true;
      }
    }
    let tagItem = sessionStorage.getItem('tagItem');
    const tag = app.store.getBy('tags', 'slug', tagItem);
    let isAllTag = tag && tag.isAllTag();
    // if (app.current.matches(TagView)) {
    //   params.filter = {'isAllTag': false}
    //   if (isAllTag) {
    //     params.filter = {'isAllTag': true}
    //   }
    // }

  });

  // extend(DiscussionListState.prototype, 'sortMap', function (map) {
  //   map.essence = '-essence,createdAt';
    
  // });

  extend(PostControls, 'moderationControls', function (items, post) {
    let discussion = post.discussion();
    if (post.number() == 1 && discussion.canRename()) {
      items.add(
        'rename',
        <Button icon="fas fa-pencil-alt" onclick={DiscussionControls.renameAction.bind(discussion)}>
          {app.translator.trans('core.forum.discussion_controls.rename_button')}
        </Button>
      );
    }
    if (post.number() == 1 && discussion.canLock()) {
      items.add(
        'lock',
        <Button icon="fas fa-lock" onclick={DiscussionControls.lockAction.bind(discussion)}>
          {app.translator.trans(`flarum-lock.forum.discussion_controls.${discussion.isLocked() ? 'unlock' : 'lock'}_button`)}
        </Button>
      );
    }
    if (post.number() == 1 && discussion.canSticky()) {
      items.add(
        'sticky',
        <Button icon="fas fa-thumbtack" onclick={DiscussionControls.stickyAction.bind(discussion)}>
          {app.translator.trans(`flarum-sticky.forum.discussion_controls.${discussion.isSticky() ? 'unsticky' : 'sticky'}_button`)}
        </Button>
      );
    }
  });

  override(TagSelectionModal.prototype, 'content', function (original) {
    // if(app.store.models.type == 'phone') {
      if (this.loading || !this.tags) {
        return <LoadingIndicator />;
      }

      const filter = this.filter().toLowerCase();
      const primaryCount = this.primaryCount();
      const secondaryCount = this.secondaryCount();
      const tags = this.getFilteredTags();

      const inputWidth = Math.max(extractText(this.getInstruction(primaryCount, secondaryCount)).length, this.filter().length);

      return [
        <div className="Modal-body">
          <div className="TagSelectionModal-form">
            <div className="TagSelectionModal-form-input">
              <div className={'TagsInput FormControl ' + (this.focused ? 'focus' : '')} onclick={() => this.$('.TagsInput input').focus()}>
                <span className="TagsInput-selected">
                  {/* {this.selected.map((tag) => (
                    <span
                      className="TagsInput-tag"
                      onclick={() => {
                        this.removeTag(tag);
                        this.onready();
                      }}
                    >
                      {tagLabel(tag)}
                    </span>
                  ))} */}
                  {this.indexTag && (
                    <span
                      className="TagsInput-tag"
                      onclick={() => {
                        this.removeTag(this.indexTag);
                        this.onready();
                      }}
                    >
                      {tagLabel(this.indexTag)}
                    </span>
                  )}
                </span>
                <input
                  className="FormControl"
                  // placeholder={extractText(this.getInstruction(primaryCount, secondaryCount))}
                  bidi={this.filter}
                  // style={{ width: inputWidth + 'ch' }}
                  onkeydown={this.navigator.navigate.bind(this.navigator)}
                  onfocus={() => (this.focused = true)}
                  onblur={() => (this.focused = false)}
                />
              </div>
            </div>
            <div className="TagSelectionModal-form-submit App-primaryControl closeBtn">
              <Button
                type="submit"
                className="Button Button--primary"
                // disabled={!this.meetsRequirements(primaryCount, secondaryCount)}
                icon="fas fa-check lin"
              >
                {app.translator.trans('flarum-tags.lib.tag_selection_modal.submit_button')}
              </Button>
            </div>
          </div>
        </div>,

        <div className="Modal-footer">
          <ul className="TagSelectionModal-list SelectTagList">
            {tags.filter((tag) => 
          {
            if (tag.slug() === 'skyspire') return false;
            if (app.session.user) {
              return  tag.pkgId() == app.data.pkgLogo.id && !tag.isNotBasic() && ((app.session.user.isAdmin() && (tag.isAdminLook() || !tag.isHidden())) || (!app.session.user.isAdmin() && !tag.isHidden()));
            } else {
              return  tag.pkgId() == app.data.pkgLogo.id && !tag.isNotBasic() && !tag.isHidden();
            }
          }  
          ).map((tag) => {
              let name = tag.name();
              // 将字符串映射转换为 JavaScript 对象
              const obj = JSON.parse(name);
              // 创建 Map 对象并初始化
              const map = new Map(Object.entries(obj));
              // 获取特定键的值
              let localeName = map.get(app.data.locale);
              return (
                <li
                  data-index={tag.id()}
                  className={classList({
                    pinned: tag.position() !== null,
                    child: !!tag.parent(),
                    colored: !!tag.color(),
                    // selected: this.selected.includes(tag),
                    active: this.indexTag === tag,
                  })}
                  style={{ backgroundColor: tag.color() }}
                  // onmouseover={() => (this.indexTag = tag)}
                  onclick={this.toggleTag.bind(this, tag)}
                >
                  {tagIcon(tag)}
                  <span className="SelectTagListItem-name" style={{ backgroundColor: tag.color(),'--tagColor': tag.color() }}>{highlight(localeName, filter)}</span>
                  {tag.description() ? <span className="SelectTagListItem-description">{tag.description()}</span> : ''}
                </li>
              )
            })}
          </ul>
          {/* {this.attrs.limits!.allowBypassing && (
            <div className="TagSelectionModal-controls">
              <ToggleButton className="Button" onclick={() => (this.bypassReqs = !this.bypassReqs)} isToggled={this.bypassReqs}>
                {app.translator.trans('flarum-tags.lib.tag_selection_modal.bypass_requirements')}
              </ToggleButton>
            </div>
          )} */}
        </div>,
      ];
    // }else {
    //   return original();
    // }
  });

  override(DiscussionList.prototype, 'view', function (original) {
    // if(app.store.models.type == 'phone') {
      const state = this.attrs.state;
      const isAllTag = this.attrs.isAllTag;
      const params = state.getParams();
      const isLoading = state.isInitialLoading() || state.isLoadingNext();
      let loading;

      if (isLoading) {
        loading = <LoadingIndicator />;
      } else if (state.hasNext()) {
        // loading = (
        //   <Button className="Button" onclick={state.loadNext.bind(state)}>
        //     {app.translator.trans('core.forum.discussion_list.load_more_button')}
        //   </Button>
        // );
      }

      if (state.isEmpty()) {
        const text = app.translator.trans('core.forum.discussion_list.empty_text');
        return (
          <div className="DiscussionList">
            <Placeholder text={text} />
          </div>
        );
      }

      const pageSize = state.pageSize;

      return (
        <div className={classList('DiscussionList extra-DiscussionList', { 'DiscussionList--searchResults': state.isSearchResults() })}>
          <ul role="feed" aria-busy={isLoading} className="DiscussionList-discussions">
            {state.getPages().map((pg, pageNum) => {
              
              return pg.items
                .filter(discussion => {
                  const currentUser = app.session.user; // 获取当前用户
                  //主页或者综合评论
                  if (isAllTag) {
                    if (!currentUser) {
                      return !discussion.isHidden() && !discussion.tags()[0].isHidden()
                    } else if (currentUser.isAdmin()) {
                      return discussion  && !discussion.tags()[0].isHidden()
                    } else if (!currentUser.isAdmin() && (discussion.canHide() || discussion.user() === currentUser)) {
                      return discussion  && !discussion.tags()[0].isHidden() && !discussion.tags()[0].isAdminLook()
                    } else {
                      return !discussion.user().ignored() && !discussion.tags()[0].isHidden() && !discussion.tags()[0].isAdminLook() && !discussion.isHidden()
                    }
                  } else {
                    if (!currentUser) {
                      return !discussion.isHidden()
                    } else if (currentUser.isAdmin() || discussion.canHide() || discussion.user() === currentUser) {
                      return discussion
                    } else {
                      return !discussion.user().ignored() && !discussion.isHidden()
                    }
                  }
                  // return !discussion.user().ignored() && !discussion.isHidden() && !discussion.tags()[0].isHidden()
                  // return !discussion.user().ignored() && ((discussion.isHidden() && (discussion.user() === currentUser || discussion.canHide())) || !discussion.isHidden()) && ((currentUser &&  currentUser.isAdmin() && (discussion.tags()[0].isAdminLook() || !discussion.tags()[0].isHidden())) || (currentUser && !currentUser.isAdmin() && !discussion.tags()[0].isHidden()));
                })
                .map((discussion, itemNum) => {
                  return (
                    <li key={`${pageNum}-${itemNum}-${discussion.id()}`} data-id={discussion.id()} role="article" aria-setsize="-1" aria-posinset={pageNum * pageSize + itemNum}>
                      <DiscussionListItem discussion={discussion} params={params} />
                    </li>
                  )
                });
            })}
          </ul>
          {
            loading && <div className="DiscussionList-loadMore">{loading}</div>
          }
        </div>
      );
    // } else {
    //   return original();
    // }
  });
//TODO
  // extend(CommentPost.prototype, 'actionItems', function (items) {
  //   let translateStatus = app.forum.attribute('translateStatus');
  //   if(!translateStatus) {
  //     return;
  //   }
  //   const post = this.attrs.post;

  //   if (post.isHidden()) return;

  //   const sortMap = ['zh-TW','zh-CN','en'];

  //   let sortOptions = new Map();
  //   sortOptions.set('zh-TW', '繁體中文');
  //   sortOptions.set('zh-CN', '简体中文');
  //   sortOptions.set('en', 'English');
  //   // sortMap.map(element => {
  //   //   sortOptions.set(element, app.translator.trans(`dl-send.forum.resopnse_sort.${element}_button`));
  //   // });
  //   items.add(
  //     'translateText',
  //     <div className="like-btn">
  //       <Dropdown
  //       buttonClassName="Button"
  //       label={this.localeType === '' ? app.translator.trans('dl-response.forum.warn.translate'):sortOptions.get(this.localeType) || sortOptions.get(sortMap[0])}
  //       accessibleToggleLabel={app.translator.trans('core.forum.index_sort.toggle_dropdown_accessible_label')}
  //     >
  //       {Array.from(sortOptions).map((value, key) => {
  //         let label = value[1];
  //         const title = post.number() == 1 ? this.attrs.discussion.title() :'';
  //         // let active = (app.data.locale) === value[0];
  //         return (
  //           <Button icon={this.localeType === value[0] ? 'fas fa-check' : true} onclick={()=>this.translateText(post,value[0],post.contentHtml(),title)} active={this.localeType === value[0]}>
  //             {label}
  //           </Button>
  //         );
  //       })}
  //     </Dropdown>
  //     </div>
  //   );
  // });

  


}
